<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row g-3">
          <div class="col-12" v-for="setting in settings" :key="setting.key">
            <Setting :setting="setting" :community-id="communityId" :module="module" @loading="loading = $event" @reload="$emit('reload')"/>
          </div>
        </div>
      </div>
    </div>
    <SpinnerView :active="loading"/>
  </div>
</template>

<script>
import Setting from "@/systems/modules/settings/Setting.vue";
import {SpinnerView} from "@/niftybit";

export default {
  name: "SettingsSegment",
  components: {SpinnerView, Setting},
  props: {
    settings: Array,
    communityId: String,
    module: String
  },
  data() {
    return {
      loading: false
    }
  },
  emits: ["reload"]
}
</script>

<style scoped>

</style>
